export function debug(value) {
    return JSON.stringify(value);
}
